import Vue from "vue";
import App from "./App.vue";
import Login from "./Login.vue";

import vuetify from "./plugins/vuetify";
import store from "./store";
import router from "./router";

Vue.config.productionTip = false;

store.dispatch("google/init");

Vue.prototype.$backendUrl = process.env.VUE_APP_API;

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(Login),
}).$mount("#login");

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
